module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Hacks-Multitask.07212077.jpg";